"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var Pages_1 = require("./Pages");
require("../Styles/custom.css");
var NotFound_1 = require("../NotFound");
var AnonymousApp = /** @class */ (function (_super) {
    __extends(AnonymousApp, _super);
    function AnonymousApp(props) {
        return _super.call(this, props) || this;
    }
    AnonymousApp.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_1.Route, { exact: true, path: '/Registration/:path?', render: function (props) { return React.createElement(Pages_1.Registration, null); } }),
                React.createElement(react_router_1.Route, { render: function () { return React.createElement(NotFound_1.default, null); } }))));
    };
    return AnonymousApp;
}(React.Component));
exports.AnonymousApp = AnonymousApp;
//# sourceMappingURL=AnonymousApp.js.map